/** Utah's words for allergens.ts. */
export const ALLERGENS_UT = {
  /** The state rule beside Food Code 2-102.11(C)(9) and 2-103.11(O) on allergen awareness (R392-103-6, employee health and training). */
  awarenessRule: "R392-103-6",
} as const;
